import { API } from 'aws-amplify';
import requestBuilder from '@/services/graphql/requestBuilder';
import { GRAPHQL_TYPES } from '@/constants/cores';

async function trackCollectionView(variables) {
  const query = new requestBuilder({
    requestName: 'trackCollectionView',
    requestType: GRAPHQL_TYPES.MUTATION,
    requestVariables: {
      resourceId: 'String!',
      workspaceId: 'String!',
      viewType: 'TrackingViewType',
    },
    variables,
  }).buildQuery();
  const res = await API.graphql({
    query,
    variables,
  });
  return res;
}

async function trackWorkspacePageView(variables) {
  const query = new requestBuilder({
    requestName: 'trackWorkspacePageView',
    requestType: GRAPHQL_TYPES.MUTATION,
    requestVariables: {
      resourceId: 'String!',
      workspaceId: 'String!',
      viewType: 'TrackingViewType',
    },
    variables,
  }).buildQuery();
  const res = await API.graphql({
    query,
    variables,
  });
  return res;
}

async function trackProductView(variables) {
  const query = new requestBuilder({
    requestName: 'trackProductView',
    requestType: GRAPHQL_TYPES.MUTATION,
    requestVariables: {
      resourceId: 'String!',
      parentResourceId: 'String',
      workspaceId: 'String!',
      viewType: 'TrackingViewType',
    },
    variables,
  }).buildQuery();
  const res = await API.graphql({
    query,
    variables,
  });
  return res;
}

export default {
  trackWSCollectionView(variables) {
    return trackCollectionView({
      ...variables,
      viewType: 'workspace',
    });
  },
  trackCommCollectionView(variables) {
    return trackCollectionView({
      ...variables,
      viewType: 'community',
    });
  },

  trackWsProductView(variables) {
    return trackProductView({
      ...variables,
      viewType: 'workspace',
    });
  },
  trackCommProductView(variables) {
    return trackProductView({
      ...variables,
      viewType: 'community',
    });
  },

  // Unused. Not sure if we need this.
  // This is viewing your own workspace? So not tracked atm.
  trackWSPageView(variables) {
    return trackWorkspacePageView({
      ...variables,
      viewType: 'workspace',
    });
  },
  trackCommPageView(variables) {
    return trackWorkspacePageView({
      ...variables,
      viewType: 'community',
    });
  },
};
